export default __webpack_public_path__ + "static/media/error.c15147f6.gif";